export class UserModuleAnswersGeneratedLinkedinProposition {
	private _sectionName: string;
	private _value: string;

	constructor(value: string, sectionName: string) {
		this._sectionName = sectionName;
		this._value = value;
	}

	get sectionName(): string {
		return this._sectionName;
	}

	get value(): string {
		return this._value;
	}
}
